module.exports = __webpack_public_path__ + "img/relatorio-rastreabilidade.2d5c69ee.svg";